<template>
	<div class="login-container" style="background-image: url('static/img/2.jpg')">
		<div style="
        display: flex;
        width: 894px;
        height: 400px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -447px;
        margin-top: -200px;
        background-color: #fff;
        border-radius: 6px;
        box-shadow: 2px 2px 10px #909090;
      ">
			<img class="fl" src="../assets/img/1.png" style="
          width: 510px;
          height: 400px;
          display: block;
          border-radius: 6px 0 0 6px;
        " />

			<div style="width: 384px; height: 400px" class="fr">
				<div class="login-page-box">
					<rs-form :model="ruleForm2" :rules="rules2" status-icon ref="ruleForm2" label-position="left"
						label-width="0px" class="demo-ruleForm login-page">
						<div class="heade-span">碧桂园缴费系统</div>
						<rs-form-item>
							<rs-input prefix-icon="el-icon-s-custom" type="text" v-model="ruleForm2.userCode"
								@keyup.enter.native='loginUser' auto-complete="off" size="small" placeholder="请输入账号">
							</rs-input>
						</rs-form-item>
						<rs-form-item prop="password">
							<rs-input show-password prefix-icon="el-icon-unlock" type="password"
								v-model="ruleForm2.password" @keyup.enter.native='loginUser' auto-complete="off"
								placeholder="请输入密码" size="small"></rs-input>
						</rs-form-item>
						<rs-from-item prop='pwd' style="display:flex">
							<rs-input @keyup.enter.native='loginUser' auto-complete="off" size="small"
								prefix-icon="el-icon-s-custom" type="text" v-model="value" style="width:60%"
								placeholder='请输入验证码'></rs-input>
							<div class="s-canvas" @click="refreshCode">
								<sidentify :identifyCode="identifyCode"></sidentify>
							</div>

						</rs-from-item>
						<rs-form-item style="width: 100%">
							<rs-button type="primary" style="
                  width: 100%;
                  background: linear-gradient(90deg, #19b4f1, #0e73e8);
                " @click="loginUser">登录</rs-button>
						</rs-form-item>
					</rs-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import sidentify from '../Login/sidentify .vue'
	import API from "@/api/pay";
	// import secret from '../../plugins/secret'
	import secret from "@/utils/secret";
	import Utils from "@/utils/utils";
	import utils from '../../../utils/utils';
	export default {
		components: {
			// Loading
			sidentify
		},
		data() {
			return {
				oginForm: {
					verifycode: ''
				},
				value: '',
				identifyCodes: "1234567890", //验证码的数字库
				identifyCode: "", // 验证码组件传值
				logining: false,
				ruleForm2: {
					userCode: "", //hason  quo_sit@example.net
					// password: "", //123123  password
					// captcha: ""
				},
				rules2: {
					username: [{
						required: true,
						message: "请输入合法账号",
						trigger: "blur",
					}, ],
					password: [{
						required: true,
						message: "请输入密码",
						trigger: "blur",
					}, ],
					captcha: [{
						required: true,
						message: "请输入验证码",
						trigger: "blur",
					}, ],

				},
				checked: false,
				url: "/static/img/header.png",
				codeURL: "",
				key: "",

				//规则验证


			};
			// 验证码自定义验证规则
			//  const validateVerifycode = (rule, value, callback) => {
			//     if (value === "") {
			//       callback(new Error('请输入验证码'))
			//     } else if (value !== this.identifyCode) {
			//       console.log('验证码:', value);
			//       callback(new Error('验证码不正确!'))
			//     } else {
			//       callback()
			//     }
			//   }
		},
		created() {
			this.refreshCode(); //初始化验证

			//  this.randomNum()
			// console.log(   this.makeCode(this.identifyCodes, 4))
		},
		computed: {},
		methods: {

			//验证码----start
			randomNum(min, max) {
				return Math.floor(Math.random() * (max - min) + min);
			},
			refreshCode() {
				this.identifyCode = "";
				this.makeCode(this.identifyCodes, 5);
			},
			makeCode(o, l) {
				for (let i = 0; i < l; i++) {
					this.identifyCode += this.identifyCodes[
						this.randomNum(0, this.identifyCodes.length)
					];
				}
				// console.log("this.identifyCode:", this.identifyCode);
			},
			// refreshCode(){
			//       this.identifyCode=''
			//       this.makeCode(this.identifyCodes,5)
			//     },
			async loginUser() {
				let password = secret.Encrypt(this.ruleForm2.password);
				console.log(password);
				console.log(this.value.toUpperCase())
				if (this.value.toUpperCase()!= this.identifyCode || this.value == "") {
					this.$message({
						message: '请输入正确验证码'
					})
					this.value=''
					this.refreshCode()
					
				} else {
					let params = {
						userCode: this.ruleForm2.userCode,
						password: password,
						loginType: "NOPASSWD",
					};
					console.log(params);
					API.login(params).then((res) => {
						console.log(res);
						// let result = res.data;
						if (res.data.code == 200) {
							let shopVo = res.data.data.shopVo.shopId;
							console.log(shopVo);
							Utils.setSession("shopVo", shopVo);
							Utils.setLocalStorage("shopVo", shopVo);

							//pay
							let pay = res.data.data
							console.log(res.data.sessionId)
							Utils.setSession("pay", pay);
							Utils.setLocalStorage("pay", pay);
							this.$message.success("登录成功");
							this.$router.push("/index");
						} else {
							this.$message.error(result.message);
						}
					});
				}

			},
		},
		mounted() {


		},
	};
</script>

<style scoped>
	.heade-span {
		font-size: 25px;
		font-weight: bold;
		margin-bottom: 20px;
	}

	.login-container {
		position: fixed;
		top: 0px;
		left: 0px;
		right: 0px;
		bottom: 0px;
		width: 100%;
		height: 100%;
		background-repeat: no-repeat;
		background-size: cover;
		height: 100%;
	}

	.login-page-box {
		width: 384px;
		height: 400px;
	}

	.login-page {
		width: 304px;
		margin: 0 auto;
		margin-top: 50px;
	}

	.title {
		margin: 0 auto;
		font-size: 22px;
		font-weight: 600;
	}

	.rs-form-item {
		margin-bottom: 20px;
	}

	label.el-checkbox.rememberme {
		margin: 0px 0px 15px;
		text-align: left;
	}
</style>
